import React, { createContext, useContext, useState } from 'react';

interface AppContextType {
  appointments: number;
  setAppointments: (appointments: number) => void;
  revenue: number;
  setRevenue: (revenue: number) => void;
}

const AppContext = createContext<AppContextType | undefined>(undefined);

export const AppProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [appointments, setAppointments] = useState(0);
  const [revenue, setRevenue] = useState(0);

  return (
    <AppContext.Provider value={{ appointments, setAppointments, revenue, setRevenue }}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = (): AppContextType => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};